"use strict";
(self["webpackChunkgrafana"] = self["webpackChunkgrafana"] || []).push([[1952,1477],{

/***/ 51814:
/***/ ((module) => {

module.exports = {"id":"loki"};

/***/ })

}]);